<template>
  <section class="roadmap">
    <div class="container">
      <h2 class="section-title">发展路线</h2>
      <p class="section-subtitle">从真实需求出发，逐步验证平台价值</p>
      
      <div class="roadmap-timeline">
        <div class="roadmap-phase">
          <div class="phase-header">
            <span class="phase-badge">Phase 1</span>
            <h3>产品基础</h3>
          </div>
          <ul class="phase-goals">
            <li>完成核心平台构建与打磨</li>
            <li>围绕真实需求探索项目协作</li>
            <li>通过授权项目验证交付流程</li>
            <li>依据成果与反馈探索能力记录</li>
            <li>根据经营情况审慎投入</li>
          </ul>
        </div>

        <div class="roadmap-arrow">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2"/>
          </svg>
        </div>

        <div class="roadmap-phase">
          <div class="phase-header">
            <span class="phase-badge">Phase 2</span>
            <h3>项目验证</h3>
          </div>
          <ul class="phase-goals">
            <li>验证参与者和企业的实际需求</li>
            <li>完善交付、验收和能力复验</li>
            <li>探索个人成长服务的实际价值</li>
            <li>按真实需求评估工具与数据服务</li>
            <li>根据验证结果规划投入</li>
          </ul>
        </div>

        <div class="roadmap-arrow">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2"/>
          </svg>
        </div>

        <div class="roadmap-phase">
          <div class="phase-header">
            <span class="phase-badge">Phase 3</span>
            <h3>持续发展</h3>
          </div>
          <ul class="phase-goals">
            <li>在验证有效后探索更多场景</li>
            <li>关注服务质量与长期可持续性</li>
            <li>持续改进项目协作体验</li>
            <li>依据事实和资源条件谨慎扩展</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DevelopmentRoadmap'
}
</script>

<style scoped>
.roadmap {
  padding: 5rem 2rem;
  background: #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.roadmap-timeline {
  display: flex;
  align-items: stretch;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.roadmap-phase {
  flex: 1;
  min-width: 280px;
  max-width: 350px;
  padding: 2rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6), rgba(10, 36, 99, 0.4));
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.roadmap-phase:hover {
  border-color: rgba(0, 217, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 217, 255, 0.2);
}

.phase-header {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.phase-badge {
  display: inline-block;
  background: linear-gradient(135deg, #0066FF, #8A2BE2);
  color: #FFFFFF;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  width: fit-content;
}

.phase-header h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0;
}

.phase-goals {
  list-style: none;
  padding: 0;
  margin: 0;
}

.phase-goals li {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.9rem;
  padding: 0.6rem 0;
  padding-left: 1.5rem;
  position: relative;
  line-height: 1.5;
}

.phase-goals li::before {
  content: '→';
  position: absolute;
  left: 0;
  color: #00D9FF;
  font-weight: 700;
}

.roadmap-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00D9FF;
  min-width: 30px;
}

.roadmap-arrow svg {
  width: 24px;
  height: 24px;
}

@media (max-width: 1024px) {
  .roadmap-timeline {
    flex-direction: column;
  }

  .roadmap-phase {
    max-width: 100%;
  }

  .roadmap-arrow {
    transform: rotate(90deg);
    min-height: 30px;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .roadmap {
    padding: 3rem 1.5rem;
  }
}
</style>
